import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { BaseApiService } from "@app/shared/services/base-api.service";
import { CompleteTaskRequestDto } from "../models";

@Injectable({
  providedIn: "root",
})
export class TitleWorkflowApiService extends BaseApiService {
  protected readonly endpoint = "/titleworkflow";
  protected readonly microservice = "orderWorkflow" as const;

  /**
   * POST /api/titleworkflow/orders/{orderId}/tasks/{orderTaskId}:complete
   */
  completeTask(
    orderId: number,
    taskId: number,
    request: CompleteTaskRequestDto,
  ): Observable<void> {
    return this.post<void, CompleteTaskRequestDto>(
      request,
      `/orders/${orderId}/tasks/${taskId}:complete`,
    );
  }
}
